import Vue from 'vue';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

Bugsnag.start({
  apiKey: 'fa8bb8bc0b18cacc2e90d3c117d60f8e',
  plugins: [new BugsnagPluginVue()],
  appVersion: process.env.VERSION,
  releaseStage: process.env.RELEASE,
  notifyReleaseStages: ['production'],
});

Bugsnag.getPlugin('vue')
  .installVueErrorHandler(Vue);
